import { ajax } from '../../../services/helper'
class ApiService {

    getProductsStocksData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/products/getList?type=product"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getProductUpdateStockStocksData = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitProducts/"+id+"/getKitsDetails"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     postProductsStocksUpdate = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/products/"+id+"/updateStock"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    makeExportCall = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brands/export"
            ajax(url, 'GET')
                .then(res => resolve(res.data))
                .catch(err => reject(err))
        })
    }
    
    getCityDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/cities/getDetailCombo"
            ajax(url, 'GET')
                .then(res => resolve(res.data))
                .catch(err => reject(err))
        })
    }

    getProductDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/products/getProductsCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    createBrand = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brands/add"
            ajax(url, 'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/ProductsStocks/services/apiservices.js